

import {
  ColumnFiltersState,
  SortingState,
  VisibilityState,
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import React, { useState } from "react";

import { Button } from "@repo/ui/components/ui/button";
import { Input } from "@repo/ui/components/ui/input";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@repo/ui/components/ui/table";
import { columns } from "./columns";

import { Download, Import, Trash2 } from "lucide-react";
//@ts-ignore
import { useInventories } from "@repo/ui/hooks/api/inventory/useInventories";
import { usePagination } from "@repo/ui/hooks/use-pagination";
import { useThrottle } from "@repo/ui/hooks/use-throttle";

import { useRouter } from "@repo/ui/hooks/use-router";
import { toast } from "sonner";
interface InventoryListProps { }


export function InventoryList({ }: InventoryListProps) {
  const router = useRouter();
  const [sorting, setSorting] = useState<SortingState>([]);
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
  const [columnVisibility, setColumnVisibility] = useState<VisibilityState>({});
  const [rowSelection, setRowSelection] = useState({});
  const { page, limit } = usePagination();
  const [search, setSearch] = useState("");
  const searchThrottle = useThrottle<string>(search, 500);
  const { data, isLoading } = useInventories(page, limit, searchThrottle);
  const serializedData = React.useMemo(() => {
    if (data) {
      //   return InventaireSerializer.arrayInventaireListoJson(data?.data);
      return [];
    }

  }, [data])
  // const printMutation = usePrintInventories();

  const table = useReactTable({
    //@ts-ignore
    data: serializedData,
    columns,
    onSortingChange: setSorting,
    onColumnFiltersChange: setColumnFilters,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    onColumnVisibilityChange: setColumnVisibility,
    onRowSelectionChange: setRowSelection,
    state: {
      sorting,
      columnFilters,
      columnVisibility,
      rowSelection,
    },
  });
  const handlePrint = async () => {
    const selectedRows = table.getFilteredSelectedRowModel().rows;
    if (selectedRows.length === 0) {
      toast.error("Please select inventories to print");
      return;
    }

    try {
      //await printMutation.mutateAsync(selectedRows.map((row) => row.original));
      router.push("/admin/print-inventaires");
    } catch (error) {
      toast.error("Failed to print inventories");
    }
  };
  const handleRowClick = (id: number) => {
    router.push(`/admin/inventaires/${id}`);
  };

  const handleSearch = (e: any) => {
    setSearch(e.target.value)
  }

  if (!data?.data.length) {
    return <div>loading</div>
  }

  return (
    <div className="p-8">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">DENDROMAP</h1>
        <div className="flex items-center gap-2">
          {/* <Button onClick={handlePrint} disabled={printMutation.isPending}>
            {printMutation.isPending ? (
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            ) : (
              <Printer className="mr-2 h-4 w-4" />
            )}
            Print Selected
          </Button> */}
          <Button className="bg-teal-500 hover:bg-teal-600">
            <Import className="mr-2 h-4 w-4" />
            IMPORT
          </Button>
          <Button variant="outline">
            <Download className="mr-2 h-4 w-4" />
            Export
          </Button>
          <Button variant="outline" className="text-red-500">
            <Trash2 className="mr-2 h-4 w-4" />
            Delete
          </Button>
        </div>
      </div>

      <div className="mb-6">
        <Input
          placeholder="Rechercher par genre ou adresse, Code Site, Identification, Date inventaire initial, Dernière intervention"
          value={search}
          onChange={(event) =>
            handleSearch(event)
          }
          className="max-w-full text-xs"
        />
      </div>

      <div className="rounded-md border">
        <Table>
          <TableHeader>
            {table.getHeaderGroups().map((headerGroup) => (
              <TableRow key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <TableHead key={header.id}>
                    {header.isPlaceholder
                      ? null
                      : flexRender(
                        header.column.columnDef.header,
                        header.getContext(),
                      )}
                  </TableHead>
                ))}
              </TableRow>
            ))}
          </TableHeader>
          <TableBody>
            {table.getRowModel().rows?.length ? (
              table.getRowModel().rows.map((row) => (
                <TableRow
                  key={row.id}
                  data-state={row.getIsSelected() && "selected"}
                >
                  {row.getVisibleCells().map((cell) => (
                    <TableCell key={cell.id}>
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext(),
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={columns.length}
                  className="h-24 text-center"
                >
                  No results.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>

      <div className="flex items-center justify-end space-x-2 py-4">
        <div className="text-sm text-muted-foreground">
          {table.getFilteredSelectedRowModel().rows.length} of{" "}
          {table.getFilteredRowModel().rows.length} row(s) selected.
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={() => table.previousPage()}
          disabled={!table.getCanPreviousPage()}
        >
          Previous
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => table.nextPage()}
          disabled={!table.getCanNextPage()}
        >
          Next
        </Button>
      </div>
    </div>
  );
}
